"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MapSourceModule = require("../../MapSourceModule");

var _index = require("../../../utils/index");

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var windFieldColors = {
  '34': '#ffff00',
  '50': '#FFA500',
  '64': '#FF0000'
};

var getWindFieldColor = function (speedKTS) {
  var defaultColor = '#000000';
  return windFieldColors[speedKTS] || defaultColor;
};

var Windfields =
/** @class */
function (_super) {
  __extends(Windfields, _super);

  function Windfields() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(Windfields.prototype, "id", {
    get: function () {
      return this.opts.id || 'tropical-windfields-current';
    },
    enumerable: false,
    configurable: true
  });

  Windfields.prototype.source = function () {
    var request = this.account.api().endpoint('tropicalcyclones').action("search"
    /* SEARCH */
    ).fields('id,position.details.windRadii,forecast.details.windRadii').filter('windfield');
    return {
      type: 'vector',
      data: {
        service: request,
        properties: {
          id: 'id',
          category: 'windSpeedKTS',
          path: 'windField'
        },
        formatter: function (data) {
          var windFields = [];

          if ((0, _index.isArray)(data)) {
            data.forEach(function (system) {
              var id = system.id,
                  position = system.position,
                  forecast = system.forecast;
              var windRadii = (0, _index.get)(position, 'details.windRadii') || [];

              if (forecast && (0, _index.isArray)(forecast)) {
                forecast.forEach(function (period) {
                  var fradii = (0, _index.get)(period, 'details.windRadii');

                  if (fradii) {
                    windRadii = windRadii.concat(fradii);
                  }
                });
              }

              if ((0, _index.isArray)(windRadii)) {
                windRadii.forEach(function (radii) {
                  if (radii.windField) {
                    var windField = {
                      id: id,
                      windSpeedKTS: radii.windSpeedKTS,
                      windSpeedMPH: radii.windSpeedMPH,
                      windField: radii.windField
                    };
                    windFields.push(windField);
                  }
                });
              }
            });
          }

          return windFields;
        }
      },
      style: {
        polygon: function (data) {
          if (data && data.windSpeedKTS) {
            return {
              fill: {
                color: getWindFieldColor(data.windSpeedKTS),
                opacity: 0.85
              }
            };
          }

          return null;
        }
      }
    };
  };

  Windfields.prototype.controls = function () {
    return {
      value: this.id,
      title: 'Windfields'
    };
  };

  Windfields.prototype.legend = function () {
    return {
      title: 'Tropical Windfields',
      code: 'tropical-windfields'
    };
  };

  return Windfields;
}(_MapSourceModule.BaseMapSourceModule);

var _default = Windfields;
exports.default = _default;
module.exports = exports.default;